<template>
  <div class="flex flex-wrap w-full justify-center z-30 sm:w-8/12">
    <template v-if="getIsMobile">
      <!-- Video container -->
      <div v-if="getVideo" class="z-30 video-container absolute bg-black">
        <button
          class="absolute top-0 left-0 outline-none z-40"
          @click="backButton"
        >
          <img :src="arrowLeft" alt="arrow left icon" class="arrow-left" />
        </button>
        <video id="video-player" width="100%" controls class="video-player">
          <source :src="getVideo.video.url" />
        </video>
      </div>
    </template>
    <template v-else>
      <div class="relative metadata-container flex justify-start">
        <button
          class="absolute top-0 right-0 -mr-4 -mt-5 outline-none z-40"
          @click="backButton"
        >
          <img :src="arrowLeft" alt="arrow left icon" class="arrow-left" />
        </button>
        <div
          v-if="show"
          class="video-container-desktop w-1/2 cursor-pointer"
          @click="show = false"
        >
          <img
            :src="getVideo ? getVideo.videoStillImage.url : ''"
            alt="Video thumbnail"
            class="video-thumbnail"
          />
        </div>
        <div v-else class="relative w-1/2 bg-black">
          <video
            id="video-player"
            height="100%"
            width="100%"
            controls
            class="video-player-desktop"
            autoplay
            :onplaying="videoPlaying()"
          >
            <source :src="getVideo ? getVideo.video.url : ''" />
          </video>
        </div>
        <div class="metadata-content w-2/3 px-10 py-12">
          <div class="font-bold lato-text lg:text-xl xl:text-2xl 2xl:text-5xl">
            {{ getVideo.longQuestion }}
          </div>
          <div
            class="font-semibold text-white lato-text pt-6 lg:text-xl xl:text-2xl 2xl:text-5xl"
          >
            {{ getContributor.name + ". " }} <br />
          </div>
          <div
            class="font-normal lato-text pt-24 lg:text-xl xl:text-2xl 2xl:text-4xl"
          >
            {{ getContributor.bio }} <br />
            {{ getVideo.topic }}
          </div>
        </div>
      </div>
      <!-- <div class="w-11/12 px-10 border">{{ getVideo }}</div> -->
    </template>
    <!-- PurgeCSS ignore -->
    <div
      class="hidden italic font-bold font-semibold text-xl text-green-400 pt-12 text-2xl pt-8 center object-center "
    ></div>
  </div>
</template>

<style scoped>
.video-container {
  height: 100vh;
  width: 100vw;
}

.video-player {
  height: 100vh;
  width: auto !important;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.video-player-desktop {
  height: 70vh;
  width: auto !important;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.arrow-left {
  filter: invert(1);
  height: 9vh;
  widows: 9vh;
}

.metadata-container {
  height: 70vh;
}

.metadata-content {
  background: #61d39c;
}

.video-thumbnail {
  height: 100%;
  width: 100%;
  object-fit: cover;
}

.lato-text {
  font-family: "Lato", sans-serif;
}
</style>

<script>
import { mapGetters, mapMutations } from "vuex";

// Components

// Assets
import arrowLeft from "../assets/arrow-left-icon.png";

export default {
  components: {},
  data() {
    return {
      arrowLeft,
      show: true,
    };
  },
  computed: {
    ...mapGetters(["getVideo", "getIsMobile"]),
    getContributor() {
      return this.getVideo.contributor;
    },
    getScreenWidth() {
      return window.screen.width;
    },
  },
  mounted() {
    /*  this.setActiveNavigation(-1); */
  },
  methods: {
    ...mapMutations(["setVideo" /* , "saveActiveState", "loadActiveState" */]),
    backButton() {
      this.setVideo(undefined);
      this.$router.push("/");
    },
    videoPlaying() {
      /* console.log(window.ga);
      console.log(this.getVideo); */
    },
  },
};
</script>
